module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.errorMessage) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), (_vm.client.calendars) ? [_c('div', {
    class: 'calendar-wrapper-' + _vm.client.calendars.length
  }, _vm._l((_vm.client.calendars), function(calendar, index) {
    return _c('ot-calendar', {
      key: index,
      attrs: {
        "control-lights": index == 0,
        "calendar": calendar
      }
    })
  }))] : [_c('svg', {
    staticClass: "initial-load",
    attrs: {
      "width": "64",
      "height": "64",
      "viewBox": "0 0 256 256",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M 118.92116,0.31550378 C 97.312376,1.833969 75.902124,8.8419443 56.876166,21.555277 6.1402803,55.457543 -13.606489,120.55765 9.7446754,176.93499 33.09584,233.31232 93.091299,265.38613 152.93835,253.48127 212.78539,241.57641 255.94948,188.98439 255.94948,127.96202 h -10.83524 c 0,55.92076 -39.44329,103.98976 -94.28698,114.89936 C 95.98359,253.77099 41.147263,224.45664 19.748324,172.79262 -1.6506234,121.12859 16.403312,61.627725 62.897542,30.559774 109.39177,-0.50815723 171.26908,5.5881488 210.80916,45.130124 l 7.66066,-7.661037 C 191.50275,10.500754 154.93579,-2.2152206 118.92116,0.31550378 Z"
    }
  })])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15a59a25","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ts/components/OtRoot.vue
// module id = 237
// module chunks = 0